import { Button } from "@chakra-ui/button";
import { FormControl, FormLabel } from "@chakra-ui/form-control";
import { Input } from "@chakra-ui/input";
import { Box, Grid, GridItem } from "@chakra-ui/layout";
import { Select } from "@chakra-ui/select";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { jobPostAction } from "../Redux/Actions/jobAction";

let initState = {
  company: "",
  position: "",
  contract: "",
  location: "",
};
const AdminJobFormPage = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState(initState);
  const { company, position, location, contract } = formData;

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });
  };
  const hanldeClick = () => {
    console.log("formData:", formData);
    dispatch(jobPostAction(formData));
    setFormData(initState);
  };
  return (
    <Box width={"400px"} rounded={8} margin="auto" mt={4} p="4" px="6" bg={"white"} color="black">
      <Grid mt={2} w="80%" m={"auto"} templateColumns="repeat(2, 1fr)" gap={2}>
        {/* 1 Company Name */}
        <GridItem colSpan={{ base: 2, md: 2 }}>
          <FormControl isRequired>
            <FormLabel>Company Name</FormLabel>
            <Input placeholder="Name" type="text" name="company" value={company} onChange={handleChange} />
          </FormControl>
        </GridItem>
        <GridItem colSpan={{ base: 2, md: 2 }}>
          {/* Position */}
          <FormControl isRequired>
            <FormLabel>Position</FormLabel>
            <Select placeholder="Select Position" name="position" value={position} onChange={handleChange}>
              <option value="Senior Software Engineer">Senior Software Engineer</option>
              <option value="Senior Application Engineer">Senior Application Engineer</option>
              <option value="Haskell and Pure Script Dev">Haskell and Pure Script Dev</option>
              <option value="Remote DevOps Engineer">Remote DevOps Engineer</option>
              <option value="Midlevel Back End Engineer">Midlevel Back End Engineer</option>
              <option value="Desktop Support Manager">Desktop Support Manager</option>
            </Select>
          </FormControl>
        </GridItem>

        <GridItem colSpan={{ base: 2, md: 2 }}>
          <FormControl isRequired>
            <FormLabel>Contract</FormLabel>
            <Select placeholder="Select Contract" name="contract" value={contract} onChange={handleChange}>
              <option value="Full-Time">Full-Time</option>
              <option value="Part-Time">Part-Time</option>
            </Select>
          </FormControl>
        </GridItem>

        <GridItem colSpan={{ base: 2, md: 2 }}>
          <FormControl isRequired>
            <FormLabel>Location</FormLabel>
            <Input placeholder="Location" type="text" name="location" value={location} onChange={handleChange} />
          </FormControl>
        </GridItem>

        {/* 8 Buttom */}
        <GridItem colSpan={2}>
          <FormControl isRequired>
            <Button colorScheme="teal" onClick={hanldeClick} w={"full"}>
              Add Job
            </Button>
          </FormControl>
        </GridItem>
      </Grid>
    </Box>
  );
};

export default AdminJobFormPage;
